import { render, staticRenderFns } from "./OpenOrderCode.vue?vue&type=template&id=dfedd99a&"
import script from "./OpenOrderCode.vue?vue&type=script&lang=js&"
export * from "./OpenOrderCode.vue?vue&type=script&lang=js&"
import style0 from "./OpenOrderCode.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports